import axios from 'axios';
import apiConfig from '../../../shared/config/api.config';

export default function cataloniaCheckinGuest(
  hotelId,
  checkinGuestId,
  language,
  email,
  guestId,
  memberId
) {
  const { host } = apiConfig;

  const path = '/checkin/v1/catalonia/:hotel-id/checkin-guest';
  const uri = `${host}${path}`.replace(':hotel-id', hotelId);

  return axios
    .get(uri, {
      params: {
        lang: language,
        idCheckinGuest: checkinGuestId,
        email,
        guestId,
        memberId,
      },
    })
    .then(res => {
      return res.data;
    });
}
